import * as React from "react";
import Svg, { Path } from "react-native-svg";
function ChevronBlueRight(props) {
    return (React.createElement(Svg, { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
        React.createElement(Path, { d: "M12.707 9.88c0 .083-.014.16-.042.229a.636.636 0 01-.146.208l-4.125 4.125a.573.573 0 01-.448.156.64.64 0 01-.447-.177c-.14-.138-.198-.288-.178-.447a.783.783 0 01.198-.428l3.667-3.666-3.667-3.667a.68.68 0 01-.187-.448.493.493 0 01.187-.448.46.46 0 01.438-.177c.18.021.333.087.458.198l4.104 4.104c.07.07.118.14.146.209.028.069.042.145.042.229z", fill: props.color || "#1434CB" })));
}
export default ChevronBlueRight;
